
import React from 'react';
import { connect } from "react-redux"
import {Action, DashboardContainer, TextLoading, VIMEO_ICON_TYPE, VimeoIcon} from "../../funcs/utils";
import { sprintf } from "sprintf-js";
import { UGMAEmailInviteRelationship } from "../../../lib/proto/ugma";
import { validateEmail } from "../../../lib/email";
import {sendUGMAInvite} from "../../dashboard/user/actions";
import { timestamp_sec_to_mmddyy_hhmmss } from "../../../lib/time";
import { UGMAInviteState} from "../../../lib/proto/ugma";
import {DEVICE_WIDTH, TWO_FACTOR_AUTH} from "../../../lib/constants";

const STATE_PROP_FORMAT = "ugma_invite_%s_%d";

const VIMEO_0 = "788100029";

const PROPS = {
  FIRST_NAME: "first_name",
  LAST_NAME: "last_name",
  EMAIL: "email",
  RELATIONSHIP: "relationship",
  CAN_SEND: "can_send",
  IS_SENDING: "is_sending",
}

const create_invite = (component, next_index) => () => {
  // Relationship value needs to be initialized
  const relationship_prop = sprintf(STATE_PROP_FORMAT, PROPS.RELATIONSHIP, next_index);
  const can_send_prop = sprintf(STATE_PROP_FORMAT, PROPS.CAN_SEND, next_index);
  const is_sending_prop = sprintf(STATE_PROP_FORMAT, PROPS.IS_SENDING, next_index);

  component.setState({
    [relationship_prop]: UGMAEmailInviteRelationship.FATHER.id,
    [can_send_prop]: false,
    [is_sending_prop]: false,
  })

  component.props.addUGMAInvite(
    component.getUsername(),
    component.props.acct_index,
    next_index);
}

const calc_can_send = (component, index) => {
  const first_prop = sprintf(STATE_PROP_FORMAT, PROPS.FIRST_NAME, index);
  const last_prop = sprintf(STATE_PROP_FORMAT, PROPS.LAST_NAME, index);
  const email_prop = sprintf(STATE_PROP_FORMAT, PROPS.EMAIL, index);
  return component.state[first_prop] !== ""
    && component.state[last_prop] !== ""
    && validateEmail(component.state[email_prop]);
}

const on_text_change = (component, state_prop, index) => ev => {
  component.setState({
    [state_prop]: ev.target.value,
  }, () => {
    const new_can_send = calc_can_send(component, index);
    const can_send_prop = sprintf(STATE_PROP_FORMAT, PROPS.CAN_SEND, index);
    if (new_can_send !== component.state[can_send_prop]) {
      component.setState({
        [can_send_prop]: new_can_send,
      })
    }
  })
}

const CELL_CONTAINER_STYLE = {
  padding: "0.2rem",
}

const DumpText = (component, prm, item) => {
  const state_prop = sprintf(STATE_PROP_FORMAT, prm, item.index);

  if (item.new_invite) {
    const style = {
      width: "100%",
    }
    const is_sending = component.state[sprintf(STATE_PROP_FORMAT, PROPS.IS_SENDING, item.index)];
    return (
      <div style={CELL_CONTAINER_STYLE}>
        <input
          id={state_prop}
          key={state_prop}
          type="text"
          style={style}
          disabled={is_sending}
          value={component.state[state_prop]}
          onChange={on_text_change(component, state_prop, item.index)}/>
      </div>
    )
  }

  return (
    <div style={CELL_CONTAINER_STYLE}>
      <span>{item[prm]}</span>
    </div>
  )
}

const on_option_change = (component, state_prop) => ev => {
  component.setState({
    [state_prop]: ev.target.value,
  })
}


const DumpRelationship = (component, prm, item) => {
  const state_prop = sprintf(STATE_PROP_FORMAT, prm, item.index);
  const options = [];
  Object.keys(UGMAEmailInviteRelationship).forEach(id => {
    const item = UGMAEmailInviteRelationship[id];
    if (item.value !== 0) {
      options.push((
        <option key={item.id} value={item.id}>
          { item.label }
        </option>
      ))
    }
  })
  const is_sending = component.state[sprintf(STATE_PROP_FORMAT, PROPS.IS_SENDING, item.index)];
  if (item.new_invite) {
    return (
      <div style={CELL_CONTAINER_STYLE}>
        <select
          style={{width: "100%"}}
          disabled={is_sending}
          onChange={on_option_change(component, state_prop)}
          value={component.state[state_prop]}>
          { options }
        </select>
      </div>
    )
  }

  return (
    <div style={CELL_CONTAINER_STYLE}>
      <span>{ UGMAEmailInviteRelationship[item.relationship].label}</span>
    </div>
  )

}

const dump_row = (key, first, last, email, relation, op, sent, style_override={}) => {
  const style = {
    display: "flex",
    flexWrap: "nowrap",
    ...style_override,
  }
  return (
    <div style={style} key={key}>
      <div style={{flex: "1"}}> { first } </div>
      <div style={{flex: "1"}}> { last } </div>
      <div style={{flex: "2"}}> { email } </div>
      <div style={{flex: "1"}}> { relation } </div>
      <div style={{flex: "0.5"}}> { op } </div>
      <div style={{flex: "1"}}> { sent } </div>
    </div>
  )
}

const dump_header = () => {
  const header_style = {
    fontWeight: "bold",
  }
  const div_style = {
    borderBottom: "1px solid black",
  }
  return dump_row(
    "header",
    (<span style={header_style}>First Name</span>),
    (<span style={header_style}>Last Name</span>),
    (<span style={header_style}>Email</span>),
    (<span style={header_style}>Relationship</span>),
    (<span style={header_style}>Status</span>),
    (<span style={header_style}>Sent Time</span>),
    div_style);

}

const on_send = (component, index) => () => {
  const is_sending_prop = sprintf(STATE_PROP_FORMAT, PROPS.IS_SENDING, index);
  component.setState({
    [is_sending_prop]: true,
  })
  const username = component.getUsername();
  const acct_index = component.props.acct_index;
  sendUGMAInvite(
    component.props.user.token,
    username, acct_index,
    component.state[sprintf(STATE_PROP_FORMAT, PROPS.FIRST_NAME, index)],
    component.state[sprintf(STATE_PROP_FORMAT, PROPS.LAST_NAME, index)],
    component.state[sprintf(STATE_PROP_FORMAT, PROPS.EMAIL, index)],
    component.state[sprintf(STATE_PROP_FORMAT, PROPS.RELATIONSHIP, index)],
    index,
    component.props.app.wlf.id)
    .then(result => {
      component.setState({
        [is_sending_prop]: false,
      })
      component.props.setUGMAItem(username, acct_index, result.item);
    })
}

const DumpState = (component, item) => {
  const can_send_prop = sprintf(STATE_PROP_FORMAT, PROPS.CAN_SEND, item.index);
  const can_send = component.state[can_send_prop];
  const is_sending = component.state[sprintf(STATE_PROP_FORMAT, PROPS.IS_SENDING, item.index)];

  if (item.new_invite) {
    const style = {
      width: "100%",
      padding: "0",
    }
    return (
      <div style={CELL_CONTAINER_STYLE}>
        <Action
          style={style}
          disabled={!can_send}
          onClick={on_send(component, item.index)}>
          <TextLoading
            label={"Send"}
            loading={is_sending}/>
        </Action>
      </div>
    )
  } else {
    let label = "Sent";
    if (item.state) {
      label = UGMAInviteState[item.state].label;
    }
    return (<span>{label}</span>);
  }
}

const DumpTimestamp = (component, item) => {

  if (item.new_invite) {
    return null;
  }

  const date_str = timestamp_sec_to_mmddyy_hhmmss(item.sent_sec);

  return (
    <div>
      <span>{date_str}</span>
    </div>
  )
}

const LABEL_STYLE = {
  width: "8rem",
  fontWeight: "bold",
};

const dump_name = (component, item, index) => {
  const container_style = {
    display: "flex",
    alignItems: "center",
  }
  return (
    <div style={container_style} key={sprintf("name_%d", index)}>
      <div style={LABEL_STYLE}>
        Name:
      </div>
      <div style={{flex: "1"}}>
        { DumpText(component, PROPS.FIRST_NAME, item) }
      </div>
      <div style={{flex: "1"}}>
        { DumpText(component, PROPS.LAST_NAME, item) }
      </div>
    </div>
  )
}

const dump_item = (component, label, prop, item, index) => {
  const container_style = {
    display: "flex",
    alignItems: "center",
  }
  return (
    <div style={container_style} key={sprintf("%s_%d", label, index)}>
      <div style={LABEL_STYLE}>
        { label }:
      </div>
      <div style={{flex: "1"}}>
        { DumpText(component, prop, item) }
      </div>
    </div>
  )
}

const dump_jsx = (label, index, jsx) => {
  const container_style = {
    display: "flex",
    alignItems: "center",
  }
  return (
    <div style={container_style} key={sprintf("%s_%d", label, index)}>
      <div style={LABEL_STYLE}>
        { label }:
      </div>
      <div style={{flex: "1"}}>
        { jsx }
      </div>
    </div>
  )
}

// button to send email invite
const DumpSendButton = (component, item, index) => {

  const can_send_prop = sprintf(STATE_PROP_FORMAT, PROPS.CAN_SEND, item.index);
  const can_send = component.state[can_send_prop];
  const is_sending = component.state[sprintf(STATE_PROP_FORMAT, PROPS.IS_SENDING, item.index)];
  const button_style = {
    padding: "0.1rem 1rem",
    margin: "0.5rem",
  }
  return (
    <div
      key={sprintf("send_%d", index)}
      style={{textAlign: "center"}}>
      <Action
        style={button_style}
        disabled={!can_send}
        onClick={on_send(component, item.index)}>
        <TextLoading
          label={"Send"}
          loading={is_sending}/>
      </Action>
    </div>
  )
}

const dump_items = (component, items, do_medium) => {
  const result = [];
  const div_style = {
    borderBottom: "1px solid black",
  }

  if (do_medium) {
    result.push((<div key="start" style={div_style}/>));
  }

  items.forEach((item, index) => {
    if (do_medium) {
      result.push(dump_name(component, item, index));
      result.push(dump_item(component, "Email", PROPS.EMAIL, item, index));
      result.push(dump_jsx("Relationship", index, DumpRelationship(component, PROPS.RELATIONSHIP, item)));

      if (item.new_invite) {
        result.push(DumpSendButton(component, item, index));
      } else {
        result.push(dump_jsx("Status", index, DumpState(component, item)));
        result.push(dump_jsx("Sent Time", index, DumpTimestamp(component, item)));
      }
      result.push((<div key={sprintf("bottom_%d", index)} style={div_style}/>));
    } else {
      result.push(
        dump_row(
          index,
          DumpText(component, PROPS.FIRST_NAME, item),
          DumpText(component, PROPS.LAST_NAME, item),
          DumpText(component, PROPS.EMAIL, item),
          DumpRelationship(component, PROPS.RELATIONSHIP, item),
          DumpState(component, item),
          DumpTimestamp(component, item),
        ));
    }

  });

  return result;
}

const get_trustee_name = component => {
  const index = 'acct_index' in component.props.args
    ? parseInt(component.props.args.acct_index, 10)
    : 0;
  const key = sprintf("%04d", index);
  const onboarding = component.props.onboarding[key];
  return onboarding.role_1_first_name + " " + onboarding.role_1_last_name;
}

const UGMAInvite_ = props => {
  // component is passed in as a prop

  const component = props.component;
  const dashboard = component.getUserDashboard();
  const data = (dashboard && 'ugma_invites' in dashboard)
    ? dashboard.ugma_invites : [];

  let next_index;
  if (data.length > 0) {
    next_index = data[data.length - 1].index + 1;
  } else {
    next_index = 0;
  }
  const trustee_name = get_trustee_name(component);
  const bold_style = {
    fontWeight: "bold",
  }
  const do_medium = props.app && props.app.width < DEVICE_WIDTH.large;

  const device_info = {
    width: props.app.width,
    height: props.app.height,
    device: props.app.device,
  };

  const icon_style = {
    marginLeft: "1rem",
  }
  const header = (
    <div>
      <VimeoIcon
        state={component.state}
        component={component}
        style={icon_style}
        video_id={VIMEO_0}
        icon={VIMEO_ICON_TYPE.AVATAR}
        id={"title_video"}
      />
    </div>
  )

  return (
    <DashboardContainer
      title={"Email Invitations for UGMA Contributions"}
      device={device_info}
      header={header}
      client={props.client}>
      <div>
        <div style={{marginBottom: "2rem"}}>
          <span>Invite as many people as you like to contribute to </span>
          <span style={bold_style}>{trustee_name}</span>
          <span>'s account.</span>
        </div>
        { !do_medium && dump_header() }
        { dump_items(component, data, do_medium) }
        <div align={"center"} style={{marginTop: "2rem"}}>
          <Action onClick={create_invite(component, next_index)}>
            Create Invite
          </Action>
        </div>
      </div>
    </DashboardContainer>
  )

};

const mapStateToProps = state => {
  return {
    app: state.app,
    client: state.client,
    user: state.user,
    dashboard: state.userDashboard,
  }
}

const maybe_load_invites = component => {

  const username = component.props.username ||
    (TWO_FACTOR_AUTH ? component.props.user.username : component.props.user.id);
  const dashboard = component.getUserDashboard();
  if (!dashboard || !('ugma_invites' in dashboard)) {
    component.props.loadUGMADashboard(
      username, component.props.acct_index, component.props.app.wlf.id);
  }
}

const UGMAInvite = connect(mapStateToProps)(UGMAInvite_);

export { UGMAInvite, maybe_load_invites };
